import Cart from 'UTILS/cart/CartObserver';

const cart = new Cart();

const cartIcon = document.querySelector('.cart-icon');
const cartIconCartCount = document.querySelectorAll('.cart-count');

function cartIconBeforeUpdate() {
  if (cartIcon) cartIcon.classList.add('u-linkDisabled');
}

function cartIconAfterUpdate({ count }) {
  if (cartIcon) cartIcon.classList.remove('u-linkDisabled');
  if (cartIconCartCount) {
    cartIconCartCount.forEach((el) => {
      // eslint-disable-next-line no-param-reassign
      el.textContent = count;
    });
  }
}

// be sure to remove disabled link if add to cart fails
function cartIconCartError() {
  if (cartIcon) cartIcon.classList.remove('u-linkDisabled');
}

cart.subscribe('beforeUpdate', cartIconBeforeUpdate);
cart.subscribe('afterUpdate', cartIconAfterUpdate);
cart.subscribe('error', cartIconCartError);
